/*
  fav
*/
/**
* Desktop/Mobile Favorites Management
*/


/************************************************
       MOBILE CTA DISPLAY/HIDE
*************************************************/
var mobile_fav_cta = $(".mob-fav-cta");
var filter = "mctp";
filter = filter.split(",");

//== displaying mobile fav CTA if on the right page
if (in_array(PAGE_CODE, filter) && PAGE_CODE) {
  mobile_fav_cta.show();
}
